import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { walletsRepository } from '../repositories/wallets.repository'
import { useMutationTracker } from '../hooks/useMutationTracker'

const WALLET_KEY = 'wallet'
const REQUEST_WITHDRAWAL_KEY = 'request-withdrawal'

export const useWallet = () => {
  const queryClient = useQueryClient()

  // Get wallet data
  const {
    data: wallet,
    isLoading: dataIsLoading,
    error: dataError,
    refetch
  } = useQuery({
    queryKey: [WALLET_KEY],
    queryFn: walletsRepository.getMyWallet
  })

  // Request withdrawal mutation
  const requestWithdrawalMutation = useMutation({
    mutationKey: [REQUEST_WITHDRAWAL_KEY],
    mutationFn: (data: {
      amount: string,
    }) => walletsRepository.requestWithdraw(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [WALLET_KEY] })
      queryClient.invalidateQueries({ queryKey: ['transactions'] })
    }
  })

  // Track mutation state
  const requestWithdrawalState = useMutationTracker(REQUEST_WITHDRAWAL_KEY)

  return {
    // Data
    wallet,
    
    // Loading and error states
    dataIsLoading,
    dataError,
    
    // Actions
    requestWithdrawal: requestWithdrawalMutation.mutate,
    refetch,
    
    // Mutation states
    requestWithdrawalLoading: requestWithdrawalState.isPending,
    requestWithdrawalError: requestWithdrawalState.error,
    requestWithdrawalSuccess: requestWithdrawalState.isSuccess,
    requestWithdrawalData: requestWithdrawalState.data
  }
}